const styles = theme => ({
  loaderWrapper: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '100%',
    height: '100%',
    placeContent: 'center',
    alignItems: 'center',
    boxSizing: 'border-box',
    zIndex: 999999,
    position: 'absolute',
    width: '100%',
    left: 0,
    right: 0,
    top: 0,
    backgroundColor: 'rgba(0,0,0,0.6)'
  },
  loaderText:{
    color: '#fff',
    marginTop: '20px',
    fontSize: '13px',
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/layouts/components/layout-loader/layout-loader.theme.style.js